import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
	IMenuItemWithAccess,
	IMenuItem,
} from 'src/components/common/types/contextMenuTypes';
import { GlobalRole } from 'src/features/auth';
import { RootState } from 'src/store';

export const useContextMenuItemsWithAccess = (
	items: IMenuItemWithAccess[],
): IMenuItem[] | undefined => {
	const userType = useSelector((state: RootState) => state.auth.user_type);
	const { siteSlug } = useParams();
	const siteRole = useSelector(
		(state: RootState) => siteSlug && state.site.siteRolesMap[siteSlug],
	);

	if (!items || !items.length) return undefined;

	const allowedItems = items.filter((item) => {
		const hasGlobalAccess = item.allowedGlobalRoles
			? item.allowedGlobalRoles.includes(userType as GlobalRole)
			: true;

		const hasSiteAccess = item.allowedSiteRoles
			? item.allowedSiteRoles.some((role) => siteRole?.includes(role))
			: true;

		return hasGlobalAccess && hasSiteAccess;
	});

	return allowedItems.length > 0 ? allowedItems : undefined;
};
